<template>
    <div>
        <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#Navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="Navigation">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <a class="navbar-brand" href="/#/organizations/users/dashboard">Home</a>
                    </li>
                </ul>
            </div>
        </nav>

        <div class="container" style="margin-top: 90px;">
            <div class="jumbotron">
                <div class="row">
                    <div class="col-lg-7">
                        <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Integration Pipeline Trigger</h1>
                    </div>
                    <div class="col-lg-5 col-sm-6 text-right">
                        <button @click="invokeTriggerPipelineManuallyCommandV1" class="btn btn-success" :disabled="!connectorIsReady">
                            <i class="fa fa-bolt" aria-hidden="true"></i>
                            <span>Run pipeline</span>
                        </button>
                    </div>
                </div>

                <span>Run integration pipeline <strong>{{pipelineName}}</strong></span>

                <hr style="border-color: #bbb; margin: 20px 0 30px;" />

                <p v-if="connectorStatus">Status: {{connectorStatus}}</p>

                <iframe v-if="connectorProviderReadPageUrl"
                        ref="connectorProviderReadPage"
                        name="connectorProviderReadPage"
                        :src="`${connectorProviderReadPageUrl}${tid}?pipelineId=${id}&connectorId=${connectorId}`"
                        style="border: none; background: none; width: 100%;">
                </iframe>

                <div class="list-group">
                    <a v-for="r in runs" :key="r.RunId"
                       class="list-group-item list-group-item-action"
                       :class="{'list-group-item-secondary': r.Queued, 'list-group-item-primary': r.Running, 'list-group-item-success': r.Succeed, 'list-group-item-danger': (r.Failed || r.Aborted) && !r.Succeed}">
                        <div class="d-flex w-100 justify-content-between">
                            <h6 class="mb-1">
                                <span v-if="r.Running">[Running]</span>
                                <span v-else-if="r.Succeed">[Succeed]</span>
                                <span v-else-if="r.Failed">[Failed({{r.FailuresCount}})]</span>
                                <span v-else-if="r.Aborted">[Aborted]</span>
                                <span v-else>[Queued]</span>
                                <span>{{r.PipelineName}}111</span>
                            </h6>
                            <small>
                                <span>{{r.LastActivityAtSinceNow}} ago</span>
                            </small>
                        </div>
                        <p class="mb-1">
                            {{r.Trigger}}
                            <span v-if="r.QueuedByName">by {{r.QueuedByName}}</span>
                            <span>{{r.QueuedAtSinceNow}} ago</span>
                            <span v-if="r.StartedAtSinceNow">/ started {{r.StartedAtSinceNow}} ago</span>
                            <span v-if="r.CompletedAtSinceNow">/ completed {{r.CompletedAtSinceNow}} ago</span>
                            <span v-if="r.FailedAtSinceNow">/ failed {{r.FailedAtSinceNow}} ago</span>
                            <span v-if="r.AbortedAtSinceNow">/ aborted {{r.AbortedAtSinceNow}} ago</span>
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useInterval } from '@composables/useInterval'
    import { useUserActivity } from '@composables/useUserActivity'
    import { usePageReloaded } from '@composables/usePageReloaded'
    import { usePipelineTriggerPage } from '@Integrations/Pipelines/pages-core'

    document.title = "Pipeline trigger"

    const connectorProviderReadPage = ref(null);

    const tid = useOrganizationUnitId()
    const id = useId()
    const pageReloaded = usePageReloaded()
    const { isUserActive } = useUserActivity(20000)

    const { useCurrentUserQuery, usePipelineTriggerQuery, useLastRunsForPipelineByUserQuery, useTriggerPipelineManuallyCommand } = usePipelineTriggerPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineTriggerQueryV1, modelPipelineTriggerQueryV1 } = usePipelineTriggerQuery(id)
    const pipelineName = computed(() => modelPipelineTriggerQueryV1.value?.Name)
    const connectorId = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorId)
    const connectorIsReady = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorIsReady)
    const connectorStatus = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorStatus)
    const connectorProviderReadPageUrl = computed(() => modelPipelineTriggerQueryV1.value?.ConnectorProviderReadPageUrl)

    const { modelLastRunsForPipelineByUserQueryV1, runLastRunsForPipelineByUserQueryV1 } = useLastRunsForPipelineByUserQuery(id, userId, false)
    const runs = computed(() => modelLastRunsForPipelineByUserQueryV1.value?.Runs ?? [])

    const { invokeTriggerPipelineManuallyCommandV1, succeedTriggerPipelineManuallyCommandV1 } = useTriggerPipelineManuallyCommand(id, tid, userId)

    useInterval(() => {
        if (isUserActive.value) {
            runPipelineTriggerQueryV1()
            runLastRunsForPipelineByUserQueryV1()
        }
    },
    5000)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineTriggerQueryV1()
    })

    watch(userId, () => userId.value && runLastRunsForPipelineByUserQueryV1())
</script>